<div class="project-component">

  <div style="display: flex; flex-direction: row; justify-content: space-between; align-items: start">
    <div *ngIf="project">
      <h2 style="font-family: Roboto, 'Helvetica Neue', sans-serif;">POAMs for: {{project.name}}</h2>
    </div>

    <div style="display: flex; flex-direction: row; margin-top: 16px;align-items:center;">
      <mat-label
        style="font-weight: bold; line-height: 24px; height: 24px; vertical-align: bottom; margin-right: 10px; cursor: pointer;"
        (click)="isFilter=false;applyFilter(false)">Show All
      </mat-label>
      <mat-slide-toggle
        class="example-margin"
        style="margin-right: 20px;"
        (change)="applyFilter($event.checked)"
        [(ngModel)]="isFilter"
      >
        Filter by Selected
      </mat-slide-toggle>

      <button mat-raised-button
              style="border-radius: 6px;margin-right: 10px;white-space: nowrap; "
              class="button" [routerLink]="['/projects', 'project', projectId]">
        Back to project
      </button>
    </div>
  </div>

  <div style="display: flex; flex-direction: row;">
    <div style="flex:0 0 30%">
      <div style="max-height: calc(100vh - 290px);overflow-y: auto;">
        <p-table [value]="poams"
                 [rows]="100"
                 [paginator]="false"
                 [style]="{'margin-top':'10px'}"
                 [expandedRowKeys]="expandedCategories"
                 dataKey="category"
                 #dashboardTable>

          <ng-template pTemplate="header">
            <tr>
              <th style="width: 5em;"></th>
              <th>
                Name
              </th>
            </tr>

          </ng-template>
          <ng-template pTemplate="body" let-item let-rowIndex="rowIndex" let-expanded="expanded" let-columns="columns">
            <tr class="ui-widget-header" *ngIf="rowGroupMetadataPoam[item.category || ' '].index === rowIndex">
              <td colspan="2">
                <a href="#" [pRowToggler]="item">
                  <i [ngClass]="expanded ? 'fa fa-fw fa-chevron-circle-down' : 'fa fa-fw fa-chevron-circle-right'"></i>
                  <span>{{item.category}}</span>
                </a>
              </td>
            </tr>
          </ng-template>

          <ng-template pTemplate="expandedrow" let-rowData let-expanded="expanded" let-columns="columns">
            <tr [ngStyle]="{ backgroundColor: selectedPoam === rowData ? '#AAAAAA' : '#FFFFFF' }">
              <td>
                    <span>
                      <i [ngClass]="rowData.open ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
                         (click)="rowData.open = !rowData.open"></i>
                    </span>
              </td>
              <td (click)="selectedPoam = rowData;applyFilter(isFilter)">
                {{rowData.name}}
              </td>
            </tr>
            <tr *ngIf="rowData.open">
              <td colspan="2" (click)="selectedPoam = rowData;applyFilter(isFilter)">
                <span style="font-weight: bold;">Weakness Description:</span>
                {{rowData.weaknessDescription}}
                <span style="font-weight: bold;margin-top: 10px;">How Identified:</span>
                {{rowData.howIdentified}}
                <span style="font-weight: bold;margin-top: 10px;">Risk Level:</span>
                {{rowData.riskLevel}}
              </td>
            </tr>
          </ng-template>


        </p-table>
      </div>
    </div>
    <div style="flex:1 1 auto; padding-left: 10px;">
      <p-table [value]="remainingControlItems"
               *ngIf="projectControlItems && projectControlItems.length > 0"
               dataKey="projectControlItemId"
               scrollHeight="calc(100vh - 290px)"
               [scrollable]="true"
               [reorderableColumns]="true"
      >

        <ng-template pTemplate="header">
          <tr>
            <th>Control</th>
            <th style="width: 5em;"></th>
            <th>POAMs</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-item let-rowIndex="rowIndex">
          <tr class="status-row"
              *ngIf="(!item.controlItem.parentControlItemId || expandedSmallItem[item.controlItem.parentControlItemId]) && (item.controlItem.parentControlItemId || (!item.subItems.length || project.displayParentRows && !project.isParentContainer))">
            <td [ngStyle]="{'padding-left': item.controlItem.parentControlItemId ? '25px' : '0.5em'}">
              <i
                [ngClass]="expandedSmallItem[item.controlItem.controlItemId] ? 'fa fa-fw fa-chevron-circle-down' : 'fa fa-fw fa-chevron-circle-right'"
                [ngStyle]="{'display': item.subItems && item.subItems.length ? 'inline-block' : 'none'}"
                (click)="expandedSmallItem[item.controlItem.controlItemId] = !expandedSmallItem[item.controlItem.controlItemId]; $event.stopPropagation(); $event.preventDefault();"></i>
              {{item.controlItem.complianceAreaControlId}}
            </td>
            <td style="width: 5em;">
              <i class="pi pi-list" style="cursor: pointer;" pTooltip="Create as Copied Text"
                 (click)="addItem(item, false)"></i>
              <i class="pi pi-link" style="cursor: pointer;" pTooltip="Create as Link"
                 (click)="addItem(item, true)"></i>
            </td>
            <td>
              <div *ngFor="let poam of item.actionPlans"
                   [ngStyle]="{ backgroundColor: poam.actionPlanTemplateId === selectedPoam.actionPlanTemplateId ? '#AAAAAA' : '#FFFFFF' }"
                   style="display: flex; flex-direction: row;">
                <div style="white-space: nowrap; text-overflow: ellipsis; overflow-x: hidden; flex:1 1 auto">{{poam.name || poam.weaknessDescription}}</div>
                <div style="flex:0 0 auto"><i (click)="deleteItem(item, poam.actionPlanId)" class="pi pi-trash"></i></div>
              </div>
            </td>
          </tr>
          <tr
            *ngIf="item.subItems.length && !item.controlItem.parentControlItemId && project.isParentContainer && project.displayParentRows">
            <td [ngStyle]="{'padding-left': item.controlItem.parentControlItemId ? '20px' : '0.5em'}">
              <i *ngIf="item.subItems.length"
                 [ngClass]="expandedSmallItem[item.controlItem.controlItemId] ? 'fa fa-fw fa-chevron-circle-down' : 'fa fa-fw fa-chevron-circle-right'"
                 [ngStyle]="{'display': item.subItems && item.subItems.length ? 'inline-block' : 'none'}"
                 (click)="expandedSmallItem[item.controlItem.controlItemId] = !expandedSmallItem[item.controlItem.controlItemId]; $event.stopPropagation(); $event.preventDefault();"></i>
              {{item.controlItem.complianceAreaControlId}}
            </td>
            <td>
              <button mat-raised-button
                      style="border-radius: 6px;margin-right: 10px;white-space: nowrap; "
                      class="button" (click)="addItem(item, false)">
                Create as Copied Text
              </button>
              <button mat-raised-button
                      style="border-radius: 6px;margin-right: 10px;white-space: nowrap; "
                      class="button" (click)="addItem(item, true)">
                Create as Link
              </button>
            </td>
            <td>
              <div *ngFor="let poam of item.actionPlans"
                   [ngStyle]="{ backgroundColor: poam.actionPlanTemplateId === selectedPoam.actionPlanTemplateId ? '#AAAAAA' : '#FFFFFF' }">{{poam.name || poam.weaknessDescription}}
                <i (click)="deleteItem(item, poam.actionPlanId)" class="pi pi-trash"></i></div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
